import { render } from "./projectSummary.vue?vue&type=template&id=22cbf610&scoped=true"
import script from "./projectSummary.vue?vue&type=script&lang=js"
export * from "./projectSummary.vue?vue&type=script&lang=js"

import "./projectSummary.vue?vue&type=style&index=0&id=22cbf610&scoped=true&lang=css"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cbf610"]])

export default __exports__